(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/fraction-payment/assets/javascripts/pay-button.js') >= 0) return;  svs.modules.push('/components/marketplace/fraction-payment/assets/javascripts/pay-button.js');
"use strict";


const Button = svs.ui.Button;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const format = svs.utils.format;
const PayButtonMultipleShares = svs.components.marketplace.fractionPayment.PayButtonMultipleShares;
const urlMapping = svs.core.urlMapping;

const PayButton = _ref => {
  let fractionPrice = _ref.fractionPrice,
    fractionPurchaseLoading = _ref.fractionPurchaseLoading,
    hasSelectNumberOfShares = _ref.hasSelectNumberOfShares,
    isSmall = _ref.isSmall,
    numberOfSharesLeft = _ref.numberOfSharesLeft,
    block = _ref.block,
    onClick = _ref.onClick,
    cantBuy = _ref.cantBuy,
    cantBuyReason = _ref.cantBuyReason,
    elemRef = _ref.elemRef,
    id = _ref.id,
    dataContainerId = _ref.dataContainerId,
    trackingLabel = _ref.trackingLabel;
  const price = format.Currency(fractionPrice);
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  if (hasSelectNumberOfShares) {
    return React.createElement(PayButtonMultipleShares, {
      cantBuy: cantBuy,
      cantBuyReason: cantBuyReason,
      elemRef: elemRef,
      fractionPurchaseLoading: fractionPurchaseLoading,
      isSmall: isSmall,
      numberOfSharesLeft: numberOfSharesLeft,
      onClick: sharesCount => onClick(sharesCount),
      trackingLabel: trackingLabel
    });
  }
  const getBuyButtonText = (cantBuy, cantBuyReason, fractionPurchaseLoading) => {
    if (cantBuy && cantBuyReason) {
      return cantBuyReason;
    }
    if (fractionPurchaseLoading) {
      return 'Betalar..';
    }
    return "K\xF6p andel";
  };
  const isAuthenticated = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const currentReturnUrl = encodeURIComponent(location.pathname);
  const loginUrl = "".concat(urlMapping.get('loginHome'), "?returnUrl=").concat(currentReturnUrl);
  return React.createElement(Button, {
    block: block || !isSmall && isSmallDevice,
    className: "pay-fraction-button qa-pay-fraction-button",
    "data-container-id": dataContainerId,
    "data-testid": "qa-pay-fraction-button",
    disabled: cantBuy,
    elemRef: elemRef,
    focus: true,
    href: !isAuthenticated ? loginUrl : undefined,
    id: id,
    onClick: event => {
      if (isAuthenticated) {
        event === null || event === void 0 || event.stopPropagation();
        event === null || event === void 0 || event.preventDefault();
        onClick();
      }
    },
    onKeyDown: event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.stopPropagation();
      }
    },
    size: isSmall ? 100 : 300,
    transparent: true
  }, getBuyButtonText(cantBuy, cantBuyReason, fractionPurchaseLoading, price));
};
setGlobal('svs.components.marketplace.fractionPayment.PayButton', PayButton);

 })(window);